export function TextClassificationIcon(props: React.SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M5.33203 9.33301C5.33203 8.0905 5.33203 7.46924 5.53502 6.97919C5.80567 6.32578 6.3248 5.80665 6.97821 5.536C7.46826 5.33301 8.08952 5.33301 9.33203 5.33301H22.6654C23.9079 5.33301 24.5291 5.33301 25.0192 5.536C25.6726 5.80665 26.1917 6.32578 26.4624 6.97919C26.6654 7.46924 26.6654 8.0905 26.6654 9.33301M11.9987 26.6663H19.9987M15.9987 5.33301V26.6663'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
